<h1 *ngIf="data.title">{{ data.title }}</h1>
<div mat-dialog-content>
	<p>{{ data.message }}</p>
</div>
<div mat-dialog-actions>
	<button class="btn btn-primary" mat-button [mat-dialog-close]="true" cdkFocusInitial>OK</button>
	&nbsp;
	<button class="btn btn-default" mat-button [mat-dialog-close]="false">Annuler</button>
</div>
